import React from "react";
import "./ConversationCard.scss";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { formatDate, formatHourFrenchLocale } from "Services/functions";
import { updateMessages } from "Redux/Actions/messagesActions";
import { GiSightDisabled } from "react-icons/gi";
import axios from "axios";

const ConversationCard = (props) => {
  // Affiche le dernier message envoyé ou reçu
  const lastMessage = props.conversationDetails.messages.sort((a, b) => {
    return new Date(b.createdAt) - new Date(a.createdAt);
  })[0];

  // Affiche le nom de l'interlocuteur
  let membersConversation = "";
  props.conversationDetails.users.forEach((user) => {
    if (user.id !== props.auth.userConnected.id)
      membersConversation = user.firstname + " " + user.surname;
  });

  // Cache une conv, si les deux la cache elle est sup sinon elle réapparait quand un des deux envoie un mesaage
  const hideConversation = () => {
    const data = {
      userId: props.auth.userConnected.id,
    };
    axios
      .post(
        `${process.env.REACT_APP_BASE_URL_API}/conversations/hide/${props.conversationDetails.id}`,
        data,
        {
          headers: props.auth.token
            ? {
                accept: "application/json",
                Authorization: `Bearer ${props.auth.token}`,
              }
            : {
                accept: "application/json",
              },
        }
      )
      .then((res) => {
        props.handleMessages({
          myConversations:
            props.messages.myConversations.length === 1
              ? []
              : props.messages.myConversations.filter(
                  (conversation) => conversation.id != res.data.id
                ),
          currentConversation:
            props.messages.myConversations.length === 1
              ? null
              : props.messages.myConversations.filter(
                  (conversation) => conversation.id != res.data.id
                )[0],
        });
      })
      .catch((error) => {
        props.auth.toast?.current?.show({
          severity: "error",
          summary: "Erreur",
          detail: error?.response?.data?.detail || "Une erreur est survenue",
          life: 5000,
        });
      });
  };

  // Change le status des messages à l'ouverture de la conv NEW => OPEN
  const openMessage = (message) => {
    const data = {
      messageStatus: `api/message_statuses/${props.messages.openId}`,
    };
    axios
      .put(
        `${process.env.REACT_APP_BASE_URL_API}/messages/${message.id}`,
        data,
        {
          accept: "application/json",
          Authorization: `Bearer ${props.auth.token}`,
        }
      )
      .catch((error) => {
        props.auth.toast?.current?.show({
          severity: "error",
          summary: "Erreur",
          detail: error?.response?.data?.detail || "Une erreur est survenue",
          life: 5000,
        });
      });
  };
  return (
    <div
      className={
        props.conversationDetails.id === props.messages.currentConversation.id
          ? "conversation isActive"
          : "conversation"
      }
      onClick={() => {
        props.conversationDetails.messages
          .filter(
            (message) =>
              message.user.id !== props.auth.userConnected.id &&
              message.messageStatus.split("/")[3] == 1
          )
          .forEach((message) => openMessage(message));

        props.conversationDetails.messages.forEach(
          (message) =>
            (message.messageStatus = `api/message_statuses/${props.messages.openId}`)
        );
        props.handleMessages({
          myConversations: props.messages.myConversations.map(
            (conversation) => {
              if (conversation.id === props.conversationDetails)
                return props.conversationDetails;
              else return conversation;
            }
          ),
          currentConversation: props.conversationDetails,
        });
      }}
    >
      <div className="conversation_top">
        <div className="conversation_top_left">
          <span>{membersConversation}</span>
          {props.conversationDetails.messages.some(
            (message) =>
              message.messageStatus.split("/")[3] == 1 &&
              message.user.id !== props.auth.userConnected.id
          ) && <div className="conversation_top_left_notification"></div>}
        </div>
        <div className="conversation_top_right">
          {lastMessage && (
            <span>
              {formatDate(new Date()) ===
              formatDate(new Date(lastMessage.createdAt))
                ? formatHourFrenchLocale(new Date(lastMessage.createdAt))
                : formatDate(new Date(lastMessage.createdAt))}
            </span>
          )}
          <a href="#" data-toggle="tooltip" title="Masquer la conversation">
            <GiSightDisabled
              className="conversation_top_right_disable"
              onClick={() => {
                hideConversation();
              }}
            ></GiSightDisabled>
          </a>
        </div>
      </div>
      {lastMessage?.user ? (
        <div className="conversation_bottom">
          {lastMessage.user.id === props.auth.userConnected.id ? (
            <b>Vous : </b>
          ) : (
            <b>
              {lastMessage.user.firstname +
                " " +
                lastMessage.user.surname +
                " : "}
            </b>
          )}

          {lastMessage.content}
        </div>
      ) : (
        <div className="conversation_bottom">Nouvelle conversation</div>
      )}
    </div>
  );
};

ConversationCard.propTypes = {
  auth: PropTypes.object,
  messages: PropTypes.object,
  conversationDetails: PropTypes.object,
  handleMessages: PropTypes.func,
};
const mapStateToProps = (state) => ({
  auth: state.auth,
  messages: state.messages,
});
const mapDispatchToProps = (dispatch) => ({
  handleMessages: (value) => {
    dispatch(updateMessages(value));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(ConversationCard);
